// extracted by mini-css-extract-plugin
export default {"projectPage":"ProjectPage_projectPage__pcKfz","projectGrid":"ProjectPage_projectGrid__GgYye","project":"ProjectPage_project__tnxe7"};